import { Component, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'SGGS';
 showGoTop = false;  

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.showGoTop = window.pageYOffset > 100;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  constructor(translate: TranslateService) {
    let baniLanguage = localStorage.getItem('language');
    if(!baniLanguage){
      localStorage.setItem('language','en');
    }

    if (baniLanguage) {
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(baniLanguage);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(baniLanguage);
    }
    else{
      translate.setDefaultLang('en');

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use('en');
    }
  }
}
